import React from 'react'
import Typewriter from 'typewriter-effect'
import '../../commonStyles.scss'
import './personal_desc.scss'

export default function PersonalDescription () {
  return (
    <div className='personal_description_root'>
      <h1 className='portfolio_name'>SAM VARGHESE</h1>
      <div className='portfolio_role'>
        <span className='role_mark'>//</span>
        <Typewriter
          onInit={typewriter => {
            typewriter
              .typeString("AI Consultant / <span class='highlight'>Big Fours</span>")
              .pauseFor(1800)
              .deleteAll(20)
              .typeString("National Winner / <span class='highlight'>Smart India Hackathon 2023</span>")
              .pauseFor(1800)
              .deleteAll(20)
              .typeString("Grant Recipient / <span class='highlight'>All India Council for Technical Education</span>")
              .pauseFor(1800)
              .deleteAll(20)
              .typeString("MBA, BTech (CE) / <span class='highlight'>NMIMS</span>")
              .pauseFor(1800)
              .deleteAll(20)
              .start()
          }}
          options={{ autoStart: true, delay: 42, deleteSpeed: 22, cursor: '▮', html: true, loop: true }}
        />
      </div>
    </div>
  )
}
